import { FormRegExp } from '../constants/FormRegExp';

export const preparePriceFormat = (price, isPence) => {
  const preparedPrice = isPence ? price / 100 : price;
  if (price) {
    return `£${preparedPrice.toString().replace(FormRegExp.PRICE, ',')}`;
  }
  return null;
};
